import { array, object, string, number } from "yup";

const OccupantSchema = object({
  name: string().nullable().optional(),
  products: array().of(
    object({
      product: string().required(),
      productForm: string().optional(),
      quantity: number()
        .optional()
        .nullable()
        .transform((_, val) => (val === Number(val) ? val : null)),
    }),
  ),
  states: array().of(string()).optional(),
  types: array().of(string()).min(1).required(),
});

export const OccupantsArraySchema = array().of(OccupantSchema);

export default OccupantSchema;
